<script lang="ts">
  import { route } from "@mateothegreat/svelte5-router";
  import { ArrowRight } from "lucide-svelte";
  import { updateMeta, injectJsonLd } from "../../seo/meta";
  import { ORGANIZATION_SCHEMA, combineSchemas, getBreadcrumbSchema } from "../../seo/schemas";
  import { BLOG_POSTS } from "./posts";

  updateMeta({
    title: "Learn — Crypto Trading Tutorials & SDK Guides | 0xfire",
    description: "Tutorials on using the Sailfish SDK to stream real-time trading data from Raydium, PumpFun, Meteora, Hyperliquid, Polymarket, and more. Protocol-specific guides with code examples.",
    ogTitle: "0xfire Learn — Trading SDK Tutorials & Guides",
    ogDescription: "Protocol-specific tutorials for streaming real-time trading data with the Sailfish SDK. Raydium, PumpFun, Meteora, Hyperliquid, Polymarket.",
    ogType: "website",
    ogImage: "https://0xfire.com/0xfire.png",
    canonical: "https://0xfire.com/learn",
    keywords: "Sailfish SDK tutorial, Raydium API, PumpFun API, Meteora API, Hyperliquid API, Polymarket API, crypto trading data, 0xfire",
  });
  injectJsonLd(combineSchemas(
    ORGANIZATION_SCHEMA,
    getBreadcrumbSchema([
      { name: "Home", url: "https://0xfire.com/" },
      { name: "Learn", url: "https://0xfire.com/learn" },
    ]),
  ));
</script>

<div class="min-h-screen bg-black text-gray-300 selection:bg-orange-900 selection:text-white">
  <div class="max-w-3xl mx-auto px-4 py-20">
    <div class="text-center mb-16">
      <div class="badge badge-outline rounded-none uppercase tracking-widest font-mono text-xs text-orange-500 border-orange-500/50 p-3 mb-6">
        Learn
      </div>
      <h1 class="text-4xl md:text-5xl font-black text-white tracking-tight mb-4">
        Tutorials & <span class="text-orange-500">Guides</span>
      </h1>
      <p class="text-lg text-gray-500">
        Protocol-specific tutorials for streaming real-time trading data with the Sailfish SDK.
      </p>
    </div>

    <div class="space-y-8">
      {#each BLOG_POSTS as post}
        <a
          use:route
          href="/learn/{post.slug}"
          class="group block bg-gray-950/40 border border-gray-800/60 rounded-sm p-8 transition-colors hover:border-orange-900/40"
        >
          <p class="text-[10px] font-mono text-gray-600 uppercase tracking-widest mb-3">{post.date}</p>
          <h2 class="text-xl font-bold text-white mb-2 group-hover:text-orange-500 transition-colors">{post.title}</h2>
          <p class="text-sm text-gray-500 leading-relaxed mb-4">{post.description}</p>
          <span class="text-xs font-mono text-orange-500 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
            Read article <ArrowRight class="size-3" />
          </span>
        </a>
      {/each}
    </div>
  </div>
</div>
